module.exports = __webpack_public_path__ + "static/media/IMG_025.c0855841.PNG";